import { IconType } from '@repo/ui/components';

export type TAlertIcon = {
  icon?: IconType;
  size?: number;
  fill?: string;
};

export type TMessageBarProps = {
  severity?: TMessageBarSeverity;
  children: React.ReactNode;
  className?: string;
  onClose?: () => void;
  dismissible?: boolean;
  alertIcon?: IconType | TAlertIcon;
  alertIconClassName?: string;
};

export enum TMessageBarSeverity {
  ERROR = 'Feil',
  WARNING = 'Advarsel',
  SUCCESS = 'Suksess',
  INFORMATION = 'Informasjon',
  NEUTRAL = 'Nøytral',
}
